module.exports = __webpack_public_path__ + "img/img_HTSi.c8358a0b.png";